import { cn } from "@/utils/classes";

/* Prop Types */
interface ButtonSkeletonProps {
  className?: string;
}

/* Button skeleton component */
export const ButtonSkeleton = ({ className }: ButtonSkeletonProps) => {
  return <div className={cn("min-h-10 h-10 max-h-10 w-20 skeleton rounded-lg", className)}></div>;
};
